import React from 'react';

interface ProgressBarProps {
  progress: number; // 0-100 퍼센트
  size?: 'sm' | 'md' | 'lg';
  showPercentage?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ 
  progress, 
  size = 'sm', 
  showPercentage = true 
}) => {
  // 0-100 범위로 제한
  const clampedProgress = Math.min(100, Math.max(0, progress));
  
  // 크기별 스타일
  const sizeStyles = {
    sm: {
      container: 'h-1.5',
      text: 'text-xs'
    },
    md: {
      container: 'h-2',
      text: 'text-sm'
    },
    lg: {
      container: 'h-3',
      text: 'text-base'
    }
  };
  
  const styles = sizeStyles[size];
  
  return (
    <div className="flex items-center justify-end gap-1 w-full">
      {/* 진척도 바 - 80% 너비, 우상단 배치 */}
      <div className={`${styles.container} w-4/5 border border-gray-300 bg-gray-100 relative overflow-hidden`}>
        {/* 진척도 채우기 - 파란색 */}
        <div 
          className="h-full bg-blue-500 transition-all duration-300 ease-out"
          style={{ width: `${clampedProgress}%` }}
        />
      </div>
      
      {/* 퍼센트 표시 */}
      {showPercentage && (
        <span className={`${styles.text} text-gray-600 font-medium`}>
          {clampedProgress}%
        </span>
      )}
    </div>
  );
};

export default ProgressBar;
